import {Injectable} from '@angular/core';
import {HttpClient} from "@angular/common/http";
import {RotationOrder} from "../model/rotationOrder";
import {Observable} from "rxjs/Observable";

@Injectable({
  providedIn: 'root'
})
export class RotationOrderService{

  constructor(private httpClient: HttpClient) {  }

    /**
     * Save / Update an array of rotation orders for a saved property specified by its id
     *
     * @param rotationOrders array of rotation order that should be added / updated to a saved property
     * @param savedPropertyId SavedProperty for which the rotation orders should be added / updated
     * @param headers headers containing the logon id of a multi user
     * @return Observable of list of updated rotation-orders
     */
    saveRotationOrders(rotationOrders: RotationOrder[], savedPropertyId: string, headers: any): Observable<RotationOrder[]> {
        return this.httpClient.post<RotationOrder[]>("/api/saved-properties/" + savedPropertyId + "/rotation-orders", rotationOrders, {headers: headers});
    }

    /**
     * Get all rotation order for a specific platformId
     * All rotation orders for all saved properties of the platform are gotten
     *
     * @param platformId Id of the platform for which the rotation orders should be gotten
     * @param headers Headers containing the loginId for a multi user
     * @return Observable of array of all gotten rotation orders
     */
    public getRotationOrdersForPlatformId(platformId, headers: any): Observable<RotationOrder[]> {
        const httpOptions = {
            withCredentials: true, //this is required so that Angular returns the Cookies received from the server. The server sends cookies in Set-Cookie header. Without this, Angular will ignore the Set-Cookie header
            headers: headers
        };
        return this.httpClient.get<RotationOrder[]>("/api/platform-profile/" + platformId + "/rotation-orders", httpOptions);
    }

    /**
     * Updates the user for a specific rotation order
     *
     * @param rotationOrderId Id of the rotation order for which the user should be updated
     * @param headers Headers containing the loginId for a multi user
     * @param updatedRotationOrder Updated rotation order containing the updated user value. All other values should be null if they should not be updated
     * @return Observable containing the updated rotation order
     */
    public updateUserForRotationOrder(rotationOrderId: string, headers: any, updatedRotationOrder: RotationOrder): Observable<RotationOrder>{
        const httpOptions = {
            withCredentials: true, //this is required so that Angular returns the Cookies received from the server. The server sends cookies in Set-Cookie header. Without this, Angular will ignore the Set-Cookie header
            headers: headers
        };
        return this.httpClient.patch<RotationOrder>("/api/rotation-orders/" + rotationOrderId, updatedRotationOrder, httpOptions);
    }
}
